module.exports = {
	config: {
		translationPrefix: 'product',
		tableComponentClass: 'templates_ttgShop_products_table_table',
		controllerComponentClass: 'templates_ttgShop_products_controller'
	},

	model: {
		nrOfElementsAttributes: {}
	},

	methods: {
		prepare: function(storage, isServer){
			if(!isServer){
				var self = this;
				self.closest(self.config.controllerComponentClass, function(controller){
					controller.find(self.config.tableComponentClass, function(table){
						self.model.nrOfElementsAttributes = ((table.resourceData.nrOfElements || {}).data || {}).attributes || {};
						self.model.nrOfElementsAttributes.nrOfVisibleElements = Object.keys(table.model.entityList || {}).length || 0;
					});
				});
			}
		}
	},

	handlers: [{
		name: 'refreshResources',
		handle: function(callerComponent) {
			if(callerComponent.componentClass === this.config.tableComponentClass && this.config.isReady && this.$.length > 0){
				this.refresh();
			}
		}
	}]
};
